import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const CadastroPage = lazy(() => import('../pages/cadastro/page'));
const EsqueciSenhaPage = lazy(() => import('../pages/esqueci-senha/page'));
const RedefinirSenhaPage = lazy(() => import('../pages/redefinir-senha/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/login',
    element: <LoginPage />
  },
  {
    path: '/cadastro',
    element: <CadastroPage />
  },
  {
    path: '/esqueci-senha',
    element: <EsqueciSenhaPage />
  },
  {
    path: '/redefinir-senha',
    element: <RedefinirSenhaPage />
  },
  {
    path: '/dashboard',
    element: <DashboardPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
